<template>
  <div class="w-full">
    <div
      class="
        data-container
        grid grid-cols-1
        md:grid-cols-2
        w-full
        gap-x-6 gap-y-4
      "
      ref="container"
      @scroll="checkScroll"
    >
      <div
        class="
          rounded-xl
          bg-white-010
          border border-transparent
          hover:border-white-040
          p-4
          w-full
          flex
          items-center
          gap-6
          cursor-pointer
        "
        @click="redirectToDao(item.daoPath)"
        v-for="(item, i) in displayedItemsArray"
        :key="i"
      >
        <div class="relative">
          <UiImg
            :src="item.daoLogo"
            :class="{
              'border-4 border-firstPos': i == 0,
              'border-4 border-secondPos': i == 1,
              'border-4 border-thirdPos': i == 2,
            }"
            class="z-0 w-12 md:w-20 h-12 md:h-20 rounded-full"
          />
          <img
            class="absolute w-6 md:w-8 h-6 md:h-8 -top-2 -left-2 z-10"
            v-if="i == 0"
            src="@\assets\icons\first-place.png"
          />
          <img
            class="absolute w-6 md:w-8 h-6 md:h-8 -top-2 -left-2 z-10"
            v-if="i == 1"
            src="@\assets\icons\second-place.png"
          />
          <img
            class="absolute w-6 md:w-8 h-6 md:h-8 -top-2 -left-2 z-10"
            v-if="i == 2"
            src="@\assets\icons\third-place.png"
          />
          <div
            v-if="i > 2"
            style="background: #999999; border: 1px solid #cccccc"
            class="
              flex
              items-center
              justify-center
              text-sm
              font-bold
              rounded-full
              absolute
              w-6
              md:w-8
              h-6
              md:h-8
              -top-2
              -left-2
              z-10
            "
          >
            {{ i + 1 > 9 ? i + 1 : '0' + (i + 1) }}
          </div>
        </div>
        <div>
          <div class="font-bold text-base md:text-xl">
            {{ item.daoName }}
            <span class="ml-2 text-xs md:text-sm text-inputActive">{{
              item.score
            }}</span>
          </div>
          <div class="flex text-base text-white-080">
            <div>Proposal:&nbsp;</div>
            <CountUp
              class="text-sm md:text-base text-white-080"
              :is-locale="true"
              :value="item.proposals"
            />
          </div>
          <div class="flex text-sm md:text-base text-white-080">
            <div>Voters:&nbsp;</div>
            <CountUp
              class="text-sm md:text-base text-white-080"
              :is-locale="true"
              :value="item.voters"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      class="grid grid-cols-1 md:grid-cols-2 w-full gap-x-6 gap-y-4"
    >
      <Skeletor
        v-for="(item, i) in [1, 2, 3, 4, 5, 6, 7, 8]"
        :key="i"
        class="w-full h-28 rounded-lg"
      ></Skeletor>
    </div>
  </div>
</template>
<script setup>
import { useReqByBool } from '@/hooks';
import { getTopDaosByGovernance } from '@/api/annualRanking.ts';
import { onMounted, computed, reactive, ref } from 'vue';
import UiImg from '@/components/UiImg.vue';
import CountUp from '@/components/CountUp.vue';
import { Skeletor } from 'vue-skeletor';

const redirectToDao = (daoPath) => {
  window.open(`/dao/${daoPath}`);
};

const container = ref(null);
const state = reactive({
  itemsList: [],
  displayedItems: 20,
});
const displayedItemsArray = computed(() => {
  // return state.itemsList.slice(0, state.displayedItems);
  return state.itemsList;
});
const checkScroll = () => {
  const containerElement = container.value;

  if (
    Math.ceil(containerElement.scrollTop) + containerElement.clientHeight >=
    containerElement.scrollHeight
  ) {
    state.displayedItems += 10;
  }
};
const { loadData, loading } = useReqByBool(async () => {
  const res = await getTopDaosByGovernance();
  console.log('daoby treasury', res);
  state.itemsList = res;
});

onMounted(() => {
  loadData();
});
</script>
<style>
.data-container {
  /* max-height: 780px; */
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
